import { render, staticRenderFns } from "./BasicReport.vue?vue&type=template&id=67563788"
import script from "./BasicReport.vue?vue&type=script&lang=js"
export * from "./BasicReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports